import script from "./DistributeRecordsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributeRecordsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DistributeRecordsDrawer.vue?vue&type=style&index=0&id=2a77e5b1&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a77e5b1"]])

export default __exports__